import { createRouter, createWebHistory, RouteRecordRaw, useRouter } from 'vue-router'
import Layout from '@/layout/Index.vue'
import { useStore } from '@/store'
import { setRoutes } from '@/utils/cookies'
import { PermissionMutationType } from '../store/modules/permission/mutation-types'
const store = useStore()

// 解析无需配置权限的路由
const constantFiles = require.context('./constantModules', true, /\.ts$/)
let constantModules: Array<RouteRecordRaw> = []
constantFiles.keys().forEach((key) => {
    if (key === './index.ts') return
    constantModules = constantModules.concat(constantFiles(key).default)
})

// 解析需要配置权限的路由
const permissionFiles = require.context('./permissionModules', true, /\.ts$/)
let permissionModules: Array<RouteRecordRaw> = []
permissionFiles.keys().forEach((key) => {
    if (key === './index.ts') return
    permissionModules = permissionModules.concat(permissionFiles(key).default)
})

// 解析错误的路由
const errorFiles = require.context('./errorModules', true, /\.ts$/)
let errorModules: Array<RouteRecordRaw> = []
errorFiles.keys().forEach((key) => {
    if (key === './index.ts') return
    errorModules = errorModules.concat(errorFiles(key).default)
})

// 导出无需配置权限的路由
export const constantRoutes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'Layout',
        component: Layout,
        redirect: '/admin',
        children: [
            {
                path: 'admin',
                name: 'Admin',
                component: () => import('../views/admin/Index.vue'),
                meta: { title: '首页', icon: 'icon-home', affix: true, hasPermission: true }
            }
        ]
    },
    ...constantModules
]

const whitePaths: string[] = []
constantRoutes.forEach((item) => {
    whitePaths.push(item.path)
})
localStorage.setItem('whitePath', whitePaths.join(','))
store.commit(PermissionMutationType.SET_WHITE_PATHS, whitePaths)

// 导出需要配置权限的路由
export const permissionRoutes: Array<RouteRecordRaw> = [
    ...permissionModules
]

// 错误页面路由
export const errorRoutes: Array<RouteRecordRaw> = [
    ...errorModules
]

// 配置路由模式
const router = createRouter({
    history: createWebHistory(),
    routes: [...constantRoutes, ...permissionRoutes, ...errorRoutes]
})

// 导出路由重置的方法
export function resetRouter() {
    const newRouter = router;
    (router as any).matcher = (newRouter as any).matcher
}

export default router
